<template>
  <div class="">

    <Tabs type="card" v-model="current">
      <TabPane label="基础信息" name="baseInfo">
        <keep-alive>
          <base-info :projectFid="projectFid" @ownerid="setOwnerid"></base-info>
        </keep-alive>
      </TabPane>
      <!--<TabPane label="经营信息" name="runInfo"></TabPane>-->
      <TabPane label="业主信息" name="ownerInfo">
        <keep-alive>
          <owner-info :projectFid="projectFid" :ownerId="ownerId" @showimg="showImg"></owner-info>
        </keep-alive>
      </TabPane>

      <TabPane label="楼栋信息" name="buildInfo">
        <keep-alive>
          <build-info :projectFid="projectFid"></build-info>
        </keep-alive>
      </TabPane>
      <TabPane label="房型信息" name="typeInfo">
        <keep-alive>
          <type-info :projectFid="projectFid"></type-info>
        </keep-alive>

      </TabPane>
      <TabPane label="项目资料" name="projectData">
        <keep-alive>
          <info :projectFid="projectFid" @showimg="showImg"></info>
        </keep-alive>
      </TabPane>
      <TabPane label="业主变更记录" name="modifyRecord">
        <keep-alive>
          <modify-info :projectFid="projectFid" ></modify-info>
        </keep-alive>

      </TabPane>
    </Tabs>
    <img-show :n="imgN" :src="imgSrc"></img-show>

  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import ImgShow from 'components/ImgShow/index'
  import BaseInfo from './components/BaseInfo'
  import OwnerInfo from './components/OwnerInfo'
  import BuildInfo from './components/BuildInfo'
  import ModifyInfo from './components/ModifyRecord'
  import TypeInfo from './components/TypeInfo'
  import Info from './components/Info'

  export default {
    components: {
      TableList,
      ImgShow,
      BaseInfo,
      OwnerInfo,
      BuildInfo,
      ModifyInfo,
      TypeInfo,
      Info
    },
    data() {
      return {
        ownerId:'',
        projectFid: '',
        current: 'baseInfo',
        dataModify: [],
        loadingModify: false,
        totalModify: 0,
        currentModify: 1,
        projectInfos: [
          {key: 'runQualificate', text: '经营资质'}, {key: 'contractFile', text: '合同附件'},
          {key: 'enginFile', text: '工程材料'}, {key: 'others', text: '其他'}
        ],
        imgN: 0,
        imgSrc: ''
      }
    },
    methods: {
      setOwnerid(value){
        this.ownerId=value
      },
      showImg(data) {
        this.imgSrc = data
        this.imgN++

      }
    },
    computed: {},
    created() {
      this.projectFid = this.$route.params.id
      if(this.$route.params.current){
        this.current=this.$route.params.current
      }

    }

  }
</script>

<style scoped>

  .info-wrapper {
    display: flex;
  }

  .content {
    padding: 30px 20px;
    box-sizing: border-box;
  }
</style>
